module.exports = __webpack_public_path__ + "static/media/logo_thg_quick_link.f889c13e.png";